import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGroupFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13 13C15.2091 13 17 14.7909 17 17V18.5C17 19.3284 16.3284 20 15.5 20H3.5C2.67157 20 2 19.3284 2 18.5V17C2 14.7909 3.79086 13 6 13H13ZM19 13.0002C20.6569 13.0002 22 14.3434 22 16.0002V17.5002C22 18.3287 21.3284 19.0002 20.5 19.0002H19V17C19 15.3645 18.2148 13.9125 17.0008 13.0002H19ZM9.5 3C11.9853 3 14 5.01472 14 7.5C14 9.98528 11.9853 12 9.5 12C7.01472 12 5 9.98528 5 7.5C5 5.01472 7.01472 3 9.5 3ZM18 6C19.6569 6 21 7.34315 21 9C21 10.6569 19.6569 12 18 12C16.3431 12 15 10.6569 15 9C15 7.34315 16.3431 6 18 6Z" })
});
export default SvgGroupFill;
